// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"web"},"children":[{"tag":"path","attrs":{"id":"fill2","fill":"props.fillColor2","d":"M2 4H22V10H2V4Z"}},{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M22 20H2V10H22V20Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M22 20V4H2V20M22 20H2M22 20V10H2V20","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M6 14L16 14M6.00391 7.00391H6V7M10.0039 7.00391H10V7M14.0039 7.00391H14V7","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const WebIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'web',
    ref,
    icon: element,
  },
));

WebIcon.displayName = 'WebIcon';

export default WebIcon;
